import styled from '@emotion/styled';

export const TopLevelStatsRoot = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(3)};
`;

export const StatCardsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.spacing(3)};
`;

export const StatCount = styled.div`
  margin: ${({ theme }) => theme.spacing(1)} 0;
  font-size: 24px;
  font-weight: 600;
  text-align: center;
`;
